/**
 * UI-only Kingpin constants. The `__ALL_LEADERS__` sentinel mirrors what
 * `KingpinPage` used to define inline; the contributor alias list is the
 * data the About-Frame modal previously hardcoded inside `KingpinPage.tsx`.
 *
 * Split out from the original `KingpinConstants.ts` so route + table +
 * status concerns don't drag the UI palette into services.
 */

/** Sentinel value of `selectedLeader` meaning "all goals". */
export const ALL_LEADERS = '__ALL_LEADERS__';

/** Aliases shown in the "Contact Us" row inside the About Frame modal. */
export const KINGPIN_CONTRIBUTOR_ALIASES: readonly string[] = ['grettb', 'miaover', 'pnikunj', 'mkteja'];

/**
 * Kingpin URL the goal links resolve to. Lives in UI constants because the
 * service tier consumes it via `${KINGPIN_GOAL_BASE_URL}${goalId}` to
 * compute `kingpinUrl` on the goal view, and the email-update-request
 * helper falls back to it when a goal lacks a precomputed URL.
 */
export const KINGPIN_GOAL_BASE_URL = 'https://kingpin.amazon.com/#/items/';

/** Standard hex accent palette used by the Insights / Charts KPI tiles. */
export const KPI_ACCENT_HEX = {
  red: '#d91515',
  yellow: '#b48a00',
  blue: '#0972d3',
  orange: '#ff9900'
} as const;

export type KpiAccent = keyof typeof KPI_ACCENT_HEX;
